/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import BarChart from 'loracoms/BarChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';
import { toTOAUplinkTrendSeries } from '../selectors';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  option: React.PropTypes.object.isRequired,
  unitDuration: React.PropTypes.number.isRequired,
  resize: React.PropTypes.number.isRequired,
};

class GatewayTOARatioUplinkTrend extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      option: props.option,
      unitDuration: props.unitDuration,
      resize: props.resize,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statschart');
  }

  componentWillReceiveProps(nextProps) {
    const { option, unitDuration, resize } = nextProps;
    if (option !== this.props.option) {
      this.setState({ option });
    }
    if (unitDuration !== this.props.unitDuration) {
      this.setState({ unitDuration });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize });
    }
  }

  render() {
    const { unitDuration } = this.props;
    const { resize } = this.state;
    let { option } = this.state;
    option = {
      ...option,
      series: option.series.map(serie => ({
        ...serie,
        data: serie.data.map(d => (d / unitDuration) * 100),
      })),
    };

    return (
      <div className={styles.chart}>
        <BarChart
          yAxis={{
            name: this.intlMsg.msg('axis.ratio'),
            splitNumber: 5,
            min: 0,
            axisLabel: {
              formatter: x => `${Number(x).toFixed(3)}%`,
            },
          }}
          xAxis={{
            axisTick: { interval: 0 },
            splitArea: {
              show: true,
              interval: 0,
              areaStyle: { color: ['rgba(218, 223, 225, 0.2)', '#FFFFFF'] },
            },
          }}
          legend={{
            data: option.legend,
            formatter: x => Number(x / 1000000).toFixed(1),
          }}
          tooltip={{
            formatter: (params) => {
              const dataLines = params.map(p =>
                `<span style="display: inline-block; background: ${p.color}; width: 9px; height: 9px; border-radius: 100%;"></span> ${Number(p.seriesName / 1000000).toFixed(1)} : ${Number(p.value).toFixed(3)}%`).join('<br />');
              return `${params[0].name}<br />${dataLines}`;
            },
          }}
          dataZoom={[
            {
              fillerColor: 'rgba(228, 241, 254, 0.4)',
              dataBackground: {
                lineStyle: {
                  width: 0,
                },
                areaStyle: {
                  color: 'rgba(107, 185, 240, 0.8)',
                },
              },
            },
          ]}
          grid={{
            left: 60,
            top: 30,
            right: 30,
            bottom: 60,
          }}
          series={option.series}
          categories={option.categories}
          resize={resize}
        />
      </div>
    );
  }
}


GatewayTOARatioUplinkTrend.propTypes = propTypes;

const mapStateToProps = state => ({
  option: toTOAUplinkTrendSeries(state),
});

export default connect(
  mapStateToProps,
  null,
)(injectIntl(GatewayTOARatioUplinkTrend));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayTOARatioUplinkTrend/index.jsx